/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-deprecated */
/* eslint-disable no-underscore-dangle */
/**
 * Main container
 * imported in App.js
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import { logoutUser, updateUser, updateUserAuthorities } from "./redux/actions/authActions";
import { checkUserLoginState, updateUserLoginState } from "./services/authorization";
import { routes, extraRoutes } from "./routing/routes";
import { routeComponent } from "./routing/route-componentMapping";
import { Notification as NotificationComponent, hideLoading } from "./shared/widgets";
import MiniDrawer from "./views/Navbar/MiniDrawer";
import { removeCookiesOnLogoutUser } from "./services/login/loginService";

class AuthenticatedWrapper extends Component {
  constructor(props) {
    super(props);
    // this.authService = AuthenticationService.getInstance();
    this.state = {
      redirectToLogin: false,
    };
  }

  componentWillMount() {
    const isUserLoggedIn = checkUserLoginState();
    if (!isUserLoggedIn || isUserLoggedIn === "null") {
      // AuthenticationService.destroyInstance();
      this.setState({ redirectToLogin: true });
    } else {
      // this.setState({
      //     viewPermission: this.authService.viewRights
      // });
      // this.props.updateUserAuthorities(this.authService.Authorities);
    }
  }

  componentDidMount() {
    /**
     * Used to get reference of notificationSystem into "this".
     */
    // eslint-disable-next-line react/no-string-refs
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) {
    const { notificationMessage } = nextProps;
    const { notificationMessage: prevNotificationMessage, isTokenExpired } = this.props;
    if (notificationMessage !== prevNotificationMessage) {
      this._notificationSystem._addNotification(
        notificationMessage.type,
        notificationMessage.message,
      );
    }
    if (isTokenExpired !== nextProps.isTokenExpired) {
      // AuthenticationService.destroyInstance();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  autoLogout() {
    try {
      const { userLogout: userLogoutProp } = this.props;
      removeCookiesOnLogoutUser();
      userLogoutProp();
    } catch (err) {
      console.log("error while logging out: ", err);
    }
  }

  render() {
    const { redirectToLogin } = this.state;
    const { isTokenExpired, location } = this.props;
    if (redirectToLogin || isTokenExpired) {
      this.autoLogout();
      return (
        <Redirect
          to={{
            pathname: extraRoutes.LOGIN,
            state: { from: location },
          }}
        />
      );
    }
    return (
      <div className="app-wrapper">
        <MiniDrawer />
        <div className="content-wrapper">
          <Switch>
            {Object.keys(routes).map((key) => (
              <Route
                key={routes[key]}
                exact
                path={routes[key]}
                component={routeComponent[routes[key]]}
              />
            ))}
          </Switch>
        </div>
        {/* eslint-disable-next-line react/no-string-refs */}
        <NotificationComponent ref="notificationSystem" />
      </div>
    );
  }
}

AuthenticatedWrapper.propTypes = {
  isTokenExpired: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  updateUserAuthorities: PropTypes.func.isRequired,
  userLogout: PropTypes.func.isRequired,
  notificationMessage: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    isTokenExpired: state.Auth.isTokenExpired,
    notificationMessage: state.Notification.message,
  };
}
const mapDispatchToProps = (dispatch) => ({
  updateUserAuthorities: (value) => {
    dispatch(updateUserAuthorities(value));
  },
  userLogout: () => {
    dispatch(hideLoading("header"));
    dispatch(logoutUser(null));
    dispatch(updateUser({}));
    updateUserLoginState(null);
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedWrapper);
